// utils/countGraphemes.ts
// A utility to count the number of grapheme clusters (user-perceived characters) in a string using Intl.Segmenter

/**
 * Returns the number of grapheme clusters (user-perceived characters) in a string using Intl.Segmenter.
 * @param str The input string
 * @param locale Optional locale for segmentation
 * @returns The grapheme cluster count
 */
export function countUserPerceivedCharacter(str: string, locale?: string): number {
  const segmenter = new Intl.Segmenter(locale, { granularity: 'grapheme' });
  return Array.from(segmenter.segment(str)).length;
}

/**
 * Returns the number of code point in a string
 * @param str The input string
 * @returns The code point count
 */
export function countCodePoints(str: string): number {
  if (!str) return 0;
  return Array.from(str).length;
}
